import { ComponentType } from 'react'

import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import { useFeaturesProvider } from '../../../Providers/features'
import RequestContractData from '../../SuperTasks/ContractData/FillInformation'
import RequestBankAccountContent from '../../SuperTasks/RequestBankAccount/FillInformation'
import RequestAdditionalInformation from '../../SuperTasks/RequestEmployeeAdditionalInformation/FillInformation'
import RequestGeneralInformationContent from '../../SuperTasks/RequestGeneralInformation/FillInformation'
import RequestIdContent from '../../SuperTasks/RequestId/FillInformation'
import SendDocumentContent from '../../SuperTasks/SendDocument/FillInformation'
import SignDocumentsContent from '../../SuperTasks/SignDocuments/FillInformation'
import SingleTaskContent from '../../SuperTasks/Single/FillInformation'
import UploadDocumentContent from '../../SuperTasks/UploadDocument/FillInformation'

export type TaskComponent = ComponentType

export const useFillInformationComponents = () => {
  const { featureAvailabilities } = useFeaturesProvider()

  const SUPER_TASKS: Partial<Record<TaskConfigurationTypes, TaskComponent>> = {
    [TaskConfigurationTypes.Single]: SingleTaskContent,
    [TaskConfigurationTypes.UploadDocument]: UploadDocumentContent,
    [TaskConfigurationTypes.SignDocuments]: featureAvailabilities.documents_templates?.available
      ? SendDocumentContent
      : SignDocumentsContent,
    [TaskConfigurationTypes.SendDocumentTemplate]: SendDocumentContent,
  }

  const DATA_COLLECTION_SUPER_TASKS: Partial<Record<DataCollectionCategories, TaskComponent>> = {
    [DataCollectionCategories.identificationNumber]: RequestIdContent,
    [DataCollectionCategories.bankInformation]: RequestBankAccountContent,
    [DataCollectionCategories.generalInformation]: RequestGeneralInformationContent,
    [DataCollectionCategories.employee_questions_cf]: RequestAdditionalInformation,
    [DataCollectionCategories.contract_data]: RequestContractData,
  }

  return Object.assign({}, SUPER_TASKS, DATA_COLLECTION_SUPER_TASKS)
}
